/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useState} from 'react'
import {useIntl} from 'react-intl'
import styled from 'styled-components'
import {create} from 'zustand'
import '@pqina/pintura/pintura.css'
import EditorJS from '@editorjs/editorjs'
import ImageTool from '@editorjs/image'
import List from '@editorjs/list'
import YoutubeEmbed from 'editorjs-youtube-embed'
import Embed from '@editorjs/embed'
import Header from '@editorjs/header'
import Quote from '@editorjs/quote'

import {ARTICLES_URL, createPersonArticle, editPersonArticle, uploadImage} from '@api/requests'
import {useArticleStore} from '@store/articles'
import {Article, PersonModel} from '@api/models'
import {useThemeMode} from '@_metronic/partials'
import {useAuth} from '@modules/auth'
import {useLang} from '@_metronic/i18n/Metronici18n'

type OpenParams = {article?: Article; personId: PersonModel['id']}

type EditArticleDrawerStore = {
  opened: boolean
  article: Article | null
  personId: PersonModel['id'] | null
  open: ({article, personId}: OpenParams) => void
  close: () => void
}

export const useEditArticleDrawerStore = create<EditArticleDrawerStore>((set) => ({
  opened: false,
  article: null,
  personId: null,
  open: (params) => set((state) => ({...state, opened: true, ...params})),
  close: () => set((state) => ({...state, opened: false, article: null, personId: null})),
}))

const EditArticleDrawer = ({}) => {
  const language = useLang()

  const intl = useIntl()
  const {currentUser} = useAuth()
  const {editArticle, addArticle} = useArticleStore()
  const {opened, close, article, personId} = useEditArticleDrawerStore()

  const [articleName, setArticleName] = useState('')
  const [articleSubTitle, setArticleSubTitle] = useState('')

  const [editor, setEditor] = useState<null | EditorJS>(null)
  const [valid, setValid] = useState(true)

  useEffect(() => {
    if (!opened) {
      setArticleName('')
      setArticleSubTitle('')
    }
  }, [opened])
  const {menuMode} = useThemeMode()
  const darkTheme = menuMode === 'dark'

  const handleUploadFile = (file) => {
    // Возвращаем Promise
    return uploadImage(file, 1)
      .then(response => {
        console.log("image", response);
        // Предположим, что response содержит URL загруженного изображения в response.url
        return {
          success: 1,
          file: {
            url: response.data.url // сюда помести реальный URL из ответа uploadImage
          }
        };
      })
      .catch(() => {
        return {
          success: 0
        };
      });
  };

  const createEditor = (content: Article | null) => {
    if (editor) {
      try {
        editor.destroy()
      } catch (e) {}
    }
    if (!content) {
      const editor_ = new EditorJS({
        autofocus: true,
        placeholder: intl.formatMessage({id: 'SIM.VIEW.WRITE_HERE'}),
        tools: {
          header: Header,
          youtubeEmbed: YoutubeEmbed,
          image: {
            class: ImageTool,
            config: {
              uploader: {
                uploadByFile:handleUploadFile,
                uploadByUrl:(url)=>{
                  console.log("uploadUrl",url)
                }
                /*byFile: `${ARTICLES_URL}/uploadFile`, // Your backend file uploader endpoint
                byUrl: `${ARTICLES_URL}/fetchUrl`, // Your endpoint that provides uploading by Url*/
              },
            },
          },
          // @ts-ignore
          embed: Embed,
          quote: Quote,
          list: {
            // @ts-ignore
            class: List,
            inlineToolbar: true,
            config: {
              defaultStyle: 'unordered',
            },
          },
        },
        holder: 'paper',
      })
      setEditor(editor_)
    } else {
      const editor_ = new EditorJS({
        autofocus: true,
        placeholder: intl.formatMessage({id: 'SIM.VIEW.WRITE_HERE'}),
        tools: {
          youtubeEmbed: YoutubeEmbed,
          header: {
            // @ts-ignore
            class: Header,
            config: {
              placeholder: intl.formatMessage({id: 'SIM.VIEW.ENTER_A_HEADER'}),
              levels: [1, 2, 3, 4],
              defaultLevel: 2,
            },
          },
          image: {
            class: ImageTool,
            config: {
              uploader: {
                uploadByFile:handleUploadFile,
                uploadByUrl:(url)=>{
                  console.log("uploadUrl",url)
                }
                /*byFile: `${ARTICLES_URL}/uploadFile`, // Your backend file uploader endpoint
                byUrl: `${ARTICLES_URL}/fetchUrl`, // Your endpoint that provides uploading by Url*/
              },
            },
          },
          // @ts-ignore
          embed: Embed,
          quote: Quote,
          list: {
            // @ts-ignore
            class: List,
            inlineToolbar: true,
            config: {
              defaultStyle: 'unordered',
            },
          },
        },
        holder: 'paper',
        data: content.doc,
      })
      setEditor(editor_)
    }
  }
  const save = (e) => {
    // console.log('### save.articleName', articleName)
    if (!articleName) {
      setValid(false)
      return
    }
    if (editor) {
      // console.log('### editor')
      editor.save().then((outputData) => {
        if (article) {
          // console.log('### article')
          editPersonArticle(currentUser?.id || 0,personId, article._id, articleName, outputData, articleSubTitle,language).then(
            (r) => {
              let data = r.data
              // console.log('### data', data)
              if (data.result) {
                editArticle(article._id, outputData, articleName, articleSubTitle, data.html)
              }
            }
          )
        } else {
          // console.log('### !article')
          createPersonArticle(currentUser?.id || 0,personId, articleName, outputData, articleSubTitle,language).then((r) => {
            let data = r.data
            if (data.result) {
              addArticle({
                _id: data.doc_id,
                sort: 0,
                publish:false,
                user_id:currentUser?.id || 0,
                html: data.html,
                person_id: personId,
                doc: outputData,
                createdAt: new Date(),
                subtitle: articleSubTitle,
                name: articleName,
              })
            }
          })
        }
        close()
        setArticleName('')
        setArticleSubTitle('')
      })
    }
  }

  useEffect(() => {
    if (opened) {
      createEditor(article)

      if (article) {
        setArticleName(article.name)
        setArticleSubTitle(article.subtitle)
      }
    }
  }, [opened, article])

  return (
    <Wrapper className='modal bg-black' data-bs-keyboard='false' tabIndex={-1} $hidden={!opened}>
      <div className='modal-dialog h-100 modal-fullscreen'>
        <div className='modal-content shadow-none'>
          <div className='modal-header'>
            <h3 className='modal-title flex-fill'>
              {intl.formatMessage({id: 'SIM.VIEW.TAB_ARTICLES'})}
            </h3>
            <button type='button' className='btn btn-light me-2' onClick={close}>
              {intl.formatMessage({id: 'ACTIONS.CANCEL'})}
            </button>
            <button onClick={save} type='button' className='btn btn-primary'>
              {intl.formatMessage({id: 'ACTIONS.SAVE'})}
            </button>
          </div>

          <div className='modal-body fs-2'>
            <div className='container' style={{maxWidth: '800px'}}>
              <div className='row'>
                <div className='col-md-6'>
                  <div className='mb-3'>
                    <label htmlFor='articleName' className='form-label'>
                      {intl.formatMessage({id: 'SIM.VIEW.TITLE'})}
                    </label>
                    <input
                      type='text'
                      value={articleName}
                      className={`form-control ${valid ? '' : 'is-invalid'}`}
                      placeholder=''
                      autoComplete='one-time-code'
                      onChange={(e) => {
                        setValid(true)
                        setArticleName(e.currentTarget.value)
                      }}
                    />
                  </div>
                </div>
                <div className='col-md-6'>
                  <div className='mb-3'>
                    <label htmlFor='articleSubTitle' className='form-label'>
                      {intl.formatMessage({id: 'SIM.VIEW.SUBTITLE'})}
                    </label>
                    <input
                      type='text'
                      value={articleSubTitle}
                      className={`form-control`}
                      placeholder=''
                      autoComplete='one-time-code'
                      onChange={(e) => {
                        setArticleSubTitle(e.currentTarget.value)
                      }}
                    />
                  </div>
                </div>
              </div>
              <hr />
              <div id='paper'></div>
            </div>
          </div>
        </div>
      </div>
    </Wrapper>
  )
}

export {EditArticleDrawer}

const Wrapper = styled.div<{$hidden: boolean}>`
  display: ${({$hidden}) => ($hidden ? 'none' : 'flex')};

  position: fixed;
  top: 0;
  right: 0;

  width: 100%;
  height: 100%;

  .ce-toolbar__plus {
    filter: invert(100%);
  }
`
